/**
 * Created by jv on 16/01/2017.
 */
var config = {
  serviceBaseURL: "/services/",
  serviceVersion: "1.0",
  stripe: {}
};

if(__DEVELOPMENT__)
{
  config.stripe.callbackUrl = "http://localhost:8080/store/order-confirmation";
  config.stripe.publicApiKey = "pk_test_Wp7QZcQviYewD6F8ILs6rOWT";
}
else
{
  config.stripe.callbackUrl = "https://my.fundels.com/store/order-confirmation";
  config.stripe.publicApiKey = "pk_live_zmECrIKNg2z0pfRs3wk7edjx";
}

module.exports = config;



// WEBPACK FOOTER //
// ./app/js/config/config.js